// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"InventoryRowCheckbox_checkbox__2ilbi","checkbox-ltr":"InventoryRowCheckbox_checkbox-ltr__1TNrj"};